__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/35bda06b2ba7f1eb54863e06b8bc726330becd2434a070206e8cd6b3/";